import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppConfig } from '../app.config';

interface ODataValueResponse<T> {
    value: T;
}

@Injectable({
    providedIn: 'root'
})
export class AggregateAndFuelService {
    constructor(
        private http: HttpClient,
        private config: AppConfig) { }

    public hasRequiredResourceUsageRoles(): Observable<boolean> {
        const url = `${this.config.backendIwsUri}IWS.PublicWebAPI/Odata/ResourceUsage/HasRequiredResourceUsageRoles()`;
        return this.http.get<ODataValueResponse<boolean> | boolean>(url)
            .pipe(map(response => typeof response === 'boolean' ? response : !!response?.value));
    }
}
